<template>
    <small>如果流程图加载失败，请<a-button type="link" @click="reloadMermaid" size="small">
        <template #icon>
            <redo-outlined/>
        </template>
        刷新
    </a-button>。或者数据不是正确流程图格式</small>
    <div v-if="this.data" v-html="mermaidCode"></div>
</template>

<script>
    import {onMounted} from 'vue';
    import mermaid from "mermaid";
    import {RedoOutlined} from '@ant-design/icons-vue';
    const reloadMermaid = ()=>{
        console.log('reloadMermaid');
        try {
            mermaid.init(undefined, document.querySelector('.mermaid'));
        } catch (e) {
            console.log('流程图报错', e)
        }
    };
    export default {
        name: "MermaidComponent",
        props: ['data', 'task'],
        components: {
            'redo-outlined': RedoOutlined
        },
        created(){
            mermaid.initialize({
                startOnLoad: true,
                securityLevel:"loose"
            })
        },
        setup(){
            onMounted(() => {
                reloadMermaid();
            })
        },
        computed: {
            mermaidCode() {
                return `
                    <div class="mermaid" id="mermaidChart${this.task}">
                      ${this.data}
                    </div>
                  `;
            }
        },
        methods: {
            reloadMermaid
        }
    }
</script>

<style scoped>

</style>